// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"118":"67862ead","446":"625bad2c","481":"0a7992dc","535":"133cc105","818":"b0e2d40b","952":"6beb5e30"}[chunkId] + ".chunk.js";
};